import React from 'react';
import './PaymentMethod.css';

const PaymentMethod = () => {
  const paymentMethods = [
    {
      id: 1,
      name: 'iDEAL',
      logo: (
        <div className="payment-logo ideal-logo">
          <span className="ideal-text">iDEAL</span>
        </div>
      )
    },
    {
      id: 2,
      name: 'Mastercard',
      logo: (
        <div className="payment-logo mastercard-logo">
          <div className="mastercard-circles">
            <div className="circle circle--red"></div>
            <div className="circle circle--orange"></div>
          </div>
          <span className="mastercard-text">mastercard</span>
        </div>
      )
    },
    {
      id: 3,
      name: 'VISA',
      logo: (
        <div className="payment-logo visa-logo">
          <div className="visa-swoosh"></div>
          <span className="visa-text">VISA</span>
        </div>
      )
    },
    {
      id: 4,
      name: 'American Express',
      logo: (
        <div className="payment-logo amex-logo">
          <span className="amex-text">AMERICAN<br/>EXPRESS</span>
        </div>
      )
    },
    {
      id: 5,
      name: 'Maestro',
      logo: (
        <div className="payment-logo maestro-logo">
          <div className="maestro-circles">
            <div className="circle circle--red"></div>
            <div className="circle circle--blue"></div>
          </div>
          <span className="maestro-text">maestro</span>
        </div>
      )
    },
    {
      id: 6,
      name: 'Billink',
      logo: (
        <div className="payment-logo billink-logo">
          <span className="billink-text">billink</span>
        </div>
      )
    },
    {
      id: 7,
      name: 'VV Cadeaukaart',
      logo: (
        <div className="payment-logo vv-logo">
          <div className="vv-square">
            <div className="vv-symbol">VV</div>
            <div className="vv-gradient"></div>
          </div>
          <div className="vv-text">
            <span className="vv-cadeau">CADEAU</span>
            <span className="vv-kaart">KAART</span>
          </div>
        </div>
      )
    },
    {
      id: 8,
      name: 'Huis & Tuin Cadeau',
      logo: (
        <div className="payment-logo huis-tuin-logo">
          <span className="huis-tuin-text">
            <span className="huis-tuin-line1">HUIS & TUIN</span>
            <span className="huis-tuin-line2">CADEAU</span>
          </span>
        </div>
      )
    },
    {
      id: 9,
      name: 'PayPal',
      logo: (
        <div className="payment-logo paypal-logo">
          <span className="paypal-text">
            <span className="paypal-pay">Pay</span>
            <span className="paypal-pal">Pal</span>
          </span>
        </div>
      )
    }
  ];

  return (
    <section className="payment-method">
      <div className="payment-method__container">
        <div className="payment-method__header">
          <h3 className="payment-method__title">We Accept</h3>
          <p className="payment-method__subtitle">Secure payment methods</p>
        </div>
        
        <div className="payment-method__logos">
          {paymentMethods.map((method) => (
            <div key={method.id} className="payment-method__item">
              {method.logo}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PaymentMethod;
